import * as api from "../../../../api/index";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { validateEmail, validatePassword } from "../../../../utils/validation";

import {
  ArrowDropDown,
  Check,
  Search,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";

import Tools from "../../../../data/tools";
import Subjects from "../../../../data/subjects";
import Languages from "../../../../data/languages";
import Services from "../../../../data/services";
import Countries from "../../../../data/countries";

import { ALERT, AUTH } from "../../../../constants/actionTypes";

import "../Signup.css";

const Signup = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [validEmail, setValidEmail] = useState(true);
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validPassword, setValidPassword] = useState(true);
  const [passwordError, setPasswordError] = useState("Okay");
  const [showPassword, setShowPassword] = useState(false);
  const [regexTools, setRegexTools] = useState(".");
  const [regexExpertise, setRegexExpertise] = useState(".");
  const [regexSourceLang, setRegexSourceLang] = useState(".");
  const [regexTargetLang, setRegexTargetLang] = useState(".");
  const [regexServices, setRegexServices] = useState(".");
  const [regexCountries, setRegexCountries] = useState(".");
  const [accountDetails, setAccountDetails] = useState({
    email: "",
    password: "",
    title: "",
    name: "",
    address: "",
    bio: "",
    country: "Select country",
    city: "",
    postal_code: "",
    phone: "",
    skype: "",
    web_page: "",
    availability: "Select Availability",
    tools: [],
    expertise: [],
    sworn: "",
    references: "",
    source_lang: "Select language",
    target_lang: "Select language",
    native: "",
    certified: "",
    services: [],
    experience: "",
    words_translated: "Total words translated",
    role: "translator",
  });
  const disable =
    accountDetails.email.trim() === "" ||
    accountDetails.password.trim() === "" ||
    accountDetails.name.trim() === "" ||
    accountDetails.title.trim() === "" ||
    accountDetails.address.trim() === "" ||
    accountDetails.bio.trim() === "" ||
    accountDetails.country === "Select country" ||
    accountDetails.availability === "Select Availability" ||
    accountDetails.expertise.length < 1 ||
    accountDetails.sworn.trim() === "" ||
    accountDetails.references.trim() === "" ||
    accountDetails.source_lang === "Select language" ||
    accountDetails.target_lang === "Select language" ||
    accountDetails.native.trim() === "" ||
    accountDetails.certified.trim() === "" ||
    accountDetails.experience.trim() === "" ||
    accountDetails.words_translated === "Total words translated" ||
    !validateEmail(accountDetails.email) ||
    validatePassword(accountDetails.password) !== "okay" ||
    loading ||
    !agreed;

  const languages = Languages.map((lang) => {
    return lang.name.split(/[,|;]/)[0];
  }).sort();

  const newRegexTools = new RegExp(regexTools, "i");
  const newRegexExpertise = new RegExp(regexExpertise, "i");
  const newRegexSourceLang = new RegExp(regexSourceLang, "i");
  const newRegexTargetLang = new RegExp(regexTargetLang, "i");
  const newRegexServices = new RegExp(regexServices, "i");
  const newRegexCountries = new RegExp(regexCountries, "i");

  const tools = Tools.filter((tool) => newRegexTools.test(tool));
  const expertise = Subjects.filter((subject) =>
    newRegexExpertise.test(subject.subject)
  );
  const sources = languages.filter((language) =>
    newRegexSourceLang.test(language)
  );
  const targets = languages.filter((language) =>
    newRegexTargetLang.test(language)
  );
  const services = Services.filter((service) => newRegexServices.test(service));
  const countries = Countries.filter((country) =>
    newRegexCountries.test(country)
  );

  const handleAccountChange = (e) => {
    if (e.target.name === "email") {
      setValidEmail(validateEmail(e.target.value));
    }
    if (e.target.name === "password") {
      let message = validatePassword(e.target.value);
      if (message === "okay") {
        setValidPassword(true);
        setPasswordError("Okay");
      } else {
        setValidPassword(false);
        setPasswordError(message);
      }
    }
    setAccountDetails({ ...accountDetails, [e.target.name]: e.target.value });
  };

  const handleSelectSingle = (type, value) => {
    if (type === "translated") {
      setAccountDetails({ ...accountDetails, words_translated: value });
      document
        .querySelector("#auth__details__translated")
        .removeAttribute("open");
    }
    if (type === "availability") {
      setAccountDetails({ ...accountDetails, availability: value });
      document
        .querySelector("#auth__details__availability")
        .removeAttribute("open");
    }
    if (type === "source") {
      setAccountDetails({ ...accountDetails, source_lang: value });
      document
        .querySelector("#auth__details__source__lang")
        .removeAttribute("open");
    }
    if (type === "target") {
      setAccountDetails({ ...accountDetails, target_lang: value });
      document
        .querySelector("#auth__details__target__lang")
        .removeAttribute("open");
    }
    if (type === "country") {
      setAccountDetails({ ...accountDetails, country: value });
      document.querySelector("#auth__details__country").removeAttribute("open");
    }
  };

  const handleSelectMultiple = (type, value) => {
    if (type === "services") {
      if (accountDetails.services.indexOf(value) !== -1)
        return setAccountDetails({
          ...accountDetails,
          services: accountDetails.services.filter(
            (service) => service !== value
          ),
        });
      setAccountDetails({
        ...accountDetails,
        services: [...accountDetails.services, value],
      });
    }
    if (type === "tools") {
      if (accountDetails.tools.indexOf(value) !== -1)
        return setAccountDetails({
          ...accountDetails,
          tools: accountDetails.tools.filter((tool) => tool !== value),
        });
      setAccountDetails({
        ...accountDetails,
        tools: [...accountDetails.tools, value],
      });
    }
    if (type === "expertise") {
      if (accountDetails.expertise.indexOf(value) !== -1)
        return setAccountDetails({
          ...accountDetails,
          expertise: accountDetails.expertise.filter((area) => area !== value),
        });
      setAccountDetails({
        ...accountDetails,
        expertise: [...accountDetails.expertise, value],
      });
    }
  };

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await api.signUp(accountDetails);
      dispatch({ type: AUTH, data });

      await api.counter({ total_translators: 1, unapproved_translators: 1 });
      await api.sendAuthEmail({
        email: accountDetails.email,
        name: accountDetails.name,
      });

      handleToDashboard(data);

      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message:
            "Confirm your emaill address with the link sent to your mail, to enjoy our full services",
          duration: 7000,
          display: true,
        },
      });
    } catch (error) {
      setLoading(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  const handleToDashboard = (user) => {
    if (user.role === "basic") history.push("/projects/index");
    if (user.role === "translator") history.push("/translator/profile");
    if (user.role === "admin") history.push("/admin/index");
  };

  const handlePasswordVisibility = () =>
    setShowPassword((showPassword) => !showPassword);

  return (
    <>
      <form className="signupForm mb-40 w-100">
        <h3 className="mt-20 mb-40">Profile Information</h3>
        <div className="d-flex justify-between mb-40">
          <label className="w-45 position-relative">
            <p className="font-heavy mb-10 ml-5">
              Emaill address<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="email"
              value={accountDetails.email}
              name="email"
              onChange={handleAccountChange}
              required
            />
            {!validEmail && <div className="error-input">Invalid Email</div>}
          </label>
          <label className="w-45 position-relative">
            <p className="font-heavy mb-10 ml-5">
              Password<sup className="font-bold ml-5">*</sup>
            </p>
            <div className="border-1 rounded d-flex justify-between align-center">
              <input
                style={{ border: "none" }}
                className="input"
                type={showPassword ? "text" : "password"}
                autoComplete="true"
                value={accountDetails.password}
                name="password"
                onChange={handleAccountChange}
                required
              />
              {accountDetails.password.length > 0 && (
                <div
                  style={{ height: "50px" }}
                  className="d-flex align-center h-100 bg-transparent pointer px-10 rounded-tr rounded-br"
                  onClick={handlePasswordVisibility}
                >
                  {!showPassword ? (
                    <VisibilityOutlined className="icon-light-grey" />
                  ) : (
                    <VisibilityOffOutlined className="icon-light-grey" />
                  )}
                </div>
              )}
            </div>
            {!validPassword && (
              <div className="error-input">{passwordError}</div>
            )}
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Title<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="text"
              value={accountDetails.title}
              name="title"
              onChange={handleAccountChange}
              required
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Full Name<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="text"
              value={accountDetails.name}
              name="name"
              onChange={handleAccountChange}
              required
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Address<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="text"
              value={accountDetails.address}
              name="address"
              onChange={handleAccountChange}
              required
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Country<sup className="font-bold ml-5">*</sup>
            </p>
            <details
              id="auth__details__country"
              className="signup__details position-relative"
            >
              <summary className="input d-flex align-center justify-between list-none">
                <span>{accountDetails.country}</span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexCountries(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {countries.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    countries.map((country) => (
                      <span
                        style={{
                          color:
                            accountDetails.country === country ? "#ff5e15" : "",
                        }}
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() => handleSelectSingle("country", country)}
                        key={country}
                      >
                        {country}
                        {accountDetails.country === country && <Check />}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">City</p>
            <input
              className="input"
              type="text"
              value={accountDetails.city}
              name="city"
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Postal Code</p>
            <input
              className="input"
              type="number"
              value={accountDetails.postal_code}
              name="postal_code"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Phone</p>
            <input
              className="input"
              type="tel"
              value={accountDetails.phone}
              name="phone"
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Skype</p>
            <input
              className="input"
              type="url"
              value={accountDetails.skype}
              name="skype"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Web-page URL</p>
            <input
              className="input"
              type="url"
              value={accountDetails.web_page}
              name="web_page"
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Availability<sup className="font-bold ml-5">*</sup>
            </p>
            <details
              id="auth__details__availability"
              className="auth__details position-relative"
            >
              <summary className="input d-flex align-center justify-between list-none">
                <span className="text-capitalise">
                  {accountDetails.availability}
                </span>
                <ArrowDropDown />
              </summary>
              <div className="auth__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex flex-column overflow-auto">
                  <span
                    style={{
                      color:
                        accountDetails.availability ===
                        "Full week, Monday through Friday"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle(
                        "availability",
                        "Full week, Monday through Friday"
                      )
                    }
                  >
                    Full week, Monday through Friday
                    {accountDetails.availability ===
                      "Full week, Monday through Friday" && <Check />}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.availability ===
                        "Full week, including weekends"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle(
                        "availability",
                        "Full week, including weekends"
                      )
                    }
                  >
                    Full week, including weekends
                    {accountDetails.availability ===
                      "Full week, including weekends" && <Check />}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.availability === "Part-time"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("availability", "Part-time")
                    }
                  >
                    Part-time
                    {accountDetails.availability === "Part-time" && <Check />}
                  </span>
                </div>
              </div>
            </details>
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Tools used</p>
            <details className="signup__details position-relative">
              <summary className="input d-flex align-center justify-between list-none">
                <span>
                  {accountDetails.tools.length} tool
                  {accountDetails.tools.length > 1 ? "s" : ""} selected
                </span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexTools(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {tools.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    tools.map((tool) => (
                      <span
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() => handleSelectMultiple("tools", tool)}
                        key={tool}
                      >
                        {tool}
                        {accountDetails.tools.indexOf(tool) !== -1 && (
                          <Check style={{ color: "#ff5e15" }} />
                        )}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Other Tools</p>
            <input
              className="input"
              type="text"
              name="other_tools"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Translation Expertise<sup className="font-bold ml-5">*</sup>
            </p>
            <details className="signup__details position-relative">
              <summary className="input d-flex align-center justify-between list-none">
                <span>
                  {accountDetails.expertise.length} expertise selected
                </span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexExpertise(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {expertise.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    expertise.map((subject) => (
                      <span
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() =>
                          handleSelectMultiple("expertise", subject.subject)
                        }
                        key={subject.subject}
                      >
                        {subject.subject}
                        {accountDetails.expertise.indexOf(subject.subject) !==
                          -1 && <Check style={{ color: "#ff5e15" }} />}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Other Expertise</p>
            <input
              className="input"
              type="text"
              name="other_expertise"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Sworn Translator<sup className="font-bold ml-5">*</sup>
            </p>
            <div className="signupForm__org input d-flex align-center justify-between">
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="Yes"
                  name="sworn"
                  onChange={handleAccountChange}
                />
                Yes
              </label>
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="No"
                  name="sworn"
                  onChange={handleAccountChange}
                />
                No
              </label>
            </div>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Are references available on request?
              <sup className="font-bold ml-5">*</sup>
            </p>
            <div className="signupForm__org input d-flex align-center justify-between">
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="Yes"
                  name="references"
                  onChange={handleAccountChange}
                />
                Yes
              </label>
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="No"
                  name="references"
                  onChange={handleAccountChange}
                />
                No
              </label>
            </div>
          </label>
        </div>
        <h3 className="mb-40">Professional Information</h3>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Source Language<sup className="font-bold ml-5">*</sup>
            </p>
            <details
              id="auth__details__source__lang"
              className="signup__details position-relative"
            >
              <summary className="input d-flex align-center justify-between list-none">
                <span>{accountDetails.source_lang}</span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexSourceLang(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {sources.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    sources.map((source) => (
                      <span
                        style={{
                          color:
                            accountDetails.source_lang === source
                              ? "#ff5e15"
                              : "",
                        }}
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() => handleSelectSingle("source", source)}
                        key={source}
                      >
                        {source}
                        {accountDetails.source_lang === source && <Check />}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Target Language<sup className="font-bold ml-5">*</sup>
            </p>
            <details
              id="auth__details__target__lang"
              className="signup__details position-relative"
            >
              <summary className="input d-flex align-center justify-between list-none">
                <span>{accountDetails.target_lang}</span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexTargetLang(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {targets.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    targets.map((target) => (
                      <span
                        style={{
                          color:
                            accountDetails.target_lang === target
                              ? "#ff5e15"
                              : "",
                        }}
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() => handleSelectSingle("target", target)}
                        key={target}
                      >
                        {target}
                        {accountDetails.target_lang === target && <Check />}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Native Speaker of Target Language
              <sup className="font-bold ml-5">*</sup>
            </p>
            <div className="signupForm__org input d-flex align-center justify-between">
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="Yes"
                  name="native"
                  onChange={handleAccountChange}
                />
                Yes
              </label>
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="No"
                  name="native"
                  onChange={handleAccountChange}
                />
                No
              </label>
            </div>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Official Translator / Linguist Degree Obtained
              <sup className="font-bold ml-5">*</sup>
            </p>
            <div className="signupForm__org input d-flex align-center justify-between">
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="Yes"
                  name="certified"
                  onChange={handleAccountChange}
                />
                Yes
              </label>
              <label>
                <input
                  className="mr-10"
                  type="radio"
                  value="No"
                  name="certified"
                  onChange={handleAccountChange}
                />
                No
              </label>
            </div>
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Services<sup className="font-bold ml-5">*</sup>
            </p>
            <details className="signup__details position-relative">
              <summary className="input d-flex align-center justify-between list-none">
                <span>
                  {accountDetails.services.length} service
                  {accountDetails.services.length > 1 ? "s" : ""} selected
                </span>
                <ArrowDropDown />
              </summary>
              <div className="signup__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex align-center border-bottom-1">
                  <input
                    className="border-0 outline-0 w-100 font-normal p-20"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setRegexServices(e.target.value)}
                  />
                  <Search className="icon-light-grey m-20" />
                </div>
                <div className="d-flex flex-column overflow-auto">
                  {services.length < 1 ? (
                    <span className="p-20">Not Found</span>
                  ) : (
                    services.map((service) => (
                      <span
                        className="signup__drop__time d-flex justify-between p-20 border-bottom-1 text-capitalise pointer"
                        onClick={() =>
                          handleSelectMultiple("services", service)
                        }
                        key={service}
                      >
                        {service}
                        {accountDetails.services.indexOf(service) !== -1 && (
                          <Check style={{ color: "#ff5e15" }} />
                        )}
                      </span>
                    ))
                  )}
                </div>
              </div>
            </details>
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">Other Services</p>
            <input
              className="input"
              type="text"
              name="other_services"
              onChange={handleAccountChange}
            />
          </label>
        </div>
        <div className="d-flex justify-between mb-40">
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Years of Experience<sup className="font-bold ml-5">*</sup>
            </p>
            <input
              className="input"
              type="number"
              value={accountDetails.experience}
              name="experience"
              onChange={handleAccountChange}
            />
          </label>
          <label className="w-45">
            <p className="font-heavy mb-10 ml-5">
              Approximated number of words translated
              <sup className="font-bold ml-5">*</sup>
            </p>
            <details
              id="auth__details__translated"
              className="auth__details position-relative"
            >
              <summary className="input d-flex align-center justify-between list-none">
                <span className="text-capitalise">
                  {accountDetails.words_translated}
                </span>
                <ArrowDropDown />
              </summary>
              <div className="auth__drop__down d-flex flex-column position-absolute w-100 z-4 border-1">
                <div className="d-flex flex-column overflow-auto">
                  <span
                    style={{
                      color:
                        accountDetails.words_translated === "up to 10,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "up to 10,000")
                    }
                  >
                    up to 10,000
                    {accountDetails.word_translated === "up to 10,000" && (
                      <Check />
                    )}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.word_translated === "10,000 to 50,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "10,000 to 50,000")
                    }
                  >
                    10,000 to 50,000
                    {accountDetails.word_translated === "10,000 to 50,000" && (
                      <Check />
                    )}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.word_translated === "50,000 to 100,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "50,000 to 100,000")
                    }
                  >
                    50,000 to 100,000
                    {accountDetails.word_translated === "50,000 to 100,000" && (
                      <Check />
                    )}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.word_translated === "100,000 to 500,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "100,000 to 500,000")
                    }
                  >
                    100,000 to 500,000
                    {accountDetails.word_translated ===
                      "100,000 to 500,000" && <Check />}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.word_translated ===
                        "500,000 to 1,000,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "500,000 to 1,000,000")
                    }
                  >
                    500,000 to 1,000,000
                    {accountDetails.word_translated ===
                      "500,000 to 1,000,000" && <Check />}
                  </span>
                  <span
                    style={{
                      color:
                        accountDetails.word_translated === "more than 1,000,000"
                          ? "#ff5e15"
                          : "",
                    }}
                    className="signup__drop__time d-flex justify-between py-10 px-20 border-bottom-1 pointer"
                    onClick={() =>
                      handleSelectSingle("translated", "More than 1,000,000")
                    }
                  >
                    more than 1,000,000
                    {accountDetails.word_translated ===
                      "more than 1,000,000" && <Check />}
                  </span>
                </div>
              </div>
            </details>
          </label>
        </div>
        <div className="">
          <label className="w-100">
            <p className="font-heavy mb-10 ml-5">
              About You<sup className="font-bold ml-5">*</sup>
            </p>
            <textarea
              className="signupForm__textarea outline-0 border-1 rounded p-20 w-100"
              value={accountDetails.bio}
              name="bio"
              onChange={handleAccountChange}
            />
          </label>
        </div>
      </form>
      <div className="d-flex flex-column align-center justify-center">
        <div>
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className="signup__terms pl-10 font-heavy">
            I agree to OneConverse Translations'{" "}
            <Link to="/terms-and-condition">Terms & Conditions</Link> and{" "}
            <Link to="/terms-and-condition">Privacy Policy</Link>
          </span>
        </div>
        <Link to="/auth/signin" className="auth__link py-10">
          Already have an account? Sign in
        </Link>
      </div>
      <button
        className="signup__btn d-flex align-center justify-center border-0 outline-0 font-normal font-bold w-100 p-10 my-20"
        style={{ opacity: disable ? "0.6" : "" }}
        disabled={disable}
        onClick={handleCreateAccount}
      >
        Create Account
        {loading && <div className="spin-white ml-10"></div>}
      </button>
    </>
  );
};

export default Signup;
